const state = {
  //选择的账号
  adCount: [],
  //选择的app
  checkedApp: {},
  /*********************  接口数据  **********************/
  //分配规则
  split_rule: {
    audience: "campaign",
    creative_category: "campaign",
    targeting: "campaign",
    budget_and_bid: "campaign",
    creative_groups: "campaign",
    title_group: "campaign",
  },
  //广告组
  draft_campaign: null,
  draft_adset: {
    //投放内容
    promote_object: null,
    //投放位置
    delivery_placement: null,
    //定向包
    targeting: null,
    // 当前定向包的id
    currentSelectedTargetingId: null,
    // 当前定向包
    currentSelectedTargeting: null,
    //人群包
    audience: null,
    currentSelectedAudience: null,
    //预算与报价
    budget_and_bid: null,
    //广告计划名称
    name_rule: null,
    //落地页
    sitepage: null,
    //其他配置
    eventInfo: null,
    //优化设置
    optimize: null,
  },
  //广告创意
  draft_ad: {
    //创意组
    creative_groups: null,
    //创意基础设置
    adCreativeBaseInfo: null,
    //标题组
    title_group: null,
    //创意分类
    creative_category: null,
  },
};

const actions = {};

const mutations = {
  //设置账号数据
  setadCount(state, data) {
    state.adCount = data;
  },
  //设置app数据
  setcheckedApp(state, data) {
    state.checkedApp = data;
  },

  //设置分配规则
  set_split_rule: (state, data) => {
    state.split_rule[data.key] = data.value;
  },
  set_allsplit_rule: (state, data) => {
    state.split_rule = data;
  },
  //设置广告组
  set_draft_campaign: (state, data) => {
    state.draft_campaign = data;
  },

  //设置基础设置-投放内容
  set_promote_object: (state, data) => {
    state.draft_adset.promote_object = data;
  },
  //设置基础设置-投放位置
  set_delivery_placement: (state, data) => {
    state.draft_adset.delivery_placement = data;
  },
  //设置定向包
  set_targeting: (state, data) => {
    state.draft_adset.targeting = data;
  },
  //设置当前选中定向包ID
  set_current_selected_targeting_id: (state, data) => {
    state.draft_adset.currentSelectedTargetingId = data;
  },
  //设置当前选中定向包数据
  set_current_selected_targeting: (state, data) => {
    state.draft_adset.currentSelectedTargeting = data;
  },
  //设置人群包
  set_audience: (state, data) => {
    state.draft_adset.audience = data;
  },
  //设置当前选中的人群包
  set_current_selected_audience: (state, data) => {
    state.draft_adset.currentSelectedAudience = data;
  },
  //设置预算和出价
  set_budget_and_bid: (state, data) => {
    state.draft_adset.budget_and_bid = data;
  },
  //设置基础设置-广告计划名称
  set_name_rule: (state, data) => {
    state.draft_adset.name_rule = data;
  },
  //设置落地页
  set_sitepage: (state, data) => {
    state.draft_adset.sitepage = data;
  },
  //设置其他数据
  set_eventInfo: (state, data) => {
    state.draft_adset.eventInfo = data;
  },
  //设置优化设置
  set_optimize: (state, data) => {
    state.draft_adset.optimize = data;
  },

  //广告创意-创意组
  set_creative_groups: (state, data) => {
    state.draft_ad.creative_groups = data;
  },
  set_creative_groupName: (state, data) => {
    //修改创意组名称
    let { name, id } = data;
    let curGroup = state.draft_ad.creative_groups.find((item) => item.itemId === id);
    if (curGroup) {
      curGroup.group_name = name;
    }
  },
  //广告创意-创意基础设置
  set_adCreativeBaseInfo: (state, data) => {
    state.draft_ad.adCreativeBaseInfo = data;
  },
  //广告创意-标题组
  set_title_group: (state, data) => {
    state.draft_ad.title_group = data;
  },
  //广告创意-创意分类
  set_creative_category: (state, data) => {
    state.draft_ad.creative_category = data;
  },
};

export default {
  state,
  actions,
  mutations,
};
